module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/color-picker/color-picker.component.scss
// module id = ./src/app/modules/common-module/components/color-picker/color-picker.component.scss
// module chunks = 9